import http from "e6-base-core/axios/config";
import { e6ModuleSettleAccountsCenterApi } from "@/config/api";
const {
  host = "",
  E6_MS_TMS_FINANCIAL_WEB = "",
  E6_MS_TMS_BUSI_WEB = "",
} = e6ModuleSettleAccountsCenterApi;

// 门店应付费用
export function areaReportPayable(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/areaReport/payable`,
    method: "post",
    data,
  });
}
// 展开详情查询接口
export function areaPayableDetail(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderInfo/areaPayableDetail`,
    method: "post",
    data,
  });
}
// 调整费用接口
export function changeFeeArea(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/areaReport/changeFee`,
    method: "post",
    data,
  });
}
// 批量调整费用
export function batchChangeFee(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/areaReport/batchChangeFee`,
    method: "post",
    data,
  });
}
// 重算接口
export function feeRecompute(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/areaReport/feeRecompute`,
    method: "post",
    data,
  });
}
// 调整账期
export function adjustOrderCompletionTime(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/areaReport/adjustOrderCompletionTime`,
    method: "post",
    data,
  });
}
export function exportAreaPayable(data) {
  return http({
    headers: { "Content-Type": "application/json" },
    responseType: "blob",
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/areaReport/export/payable`,
    method: "post",
    data,
  });
}
